import { TScheduleId } from '@/domain/FullCalendar.domain';

type TSelectedTickets = {
    [key: number]: number;
};

const NO_LIST = {
    tickets: undefined,
    maxTicketsSelected: false,
};

export const createTicketsList = (
    selectedTickets: TSelectedTickets,
    schedule?: TScheduleId | undefined
) => {
    if (!schedule) {
        return NO_LIST;
    }

    let tickets =
        schedule?.tickets && Object.values(schedule.tickets).filter(({ not_avail }) => !not_avail);

    if (!tickets) {
        return NO_LIST;
    }

    const inventories = Object.values(schedule.inventories || {}).filter(
        ({ is_avail }) => !!is_avail
    );

    const maxInventoryPlaces: number = inventories.reduce((acc, currentVal) => {
        const selectedTicketIds: string[] = Object.keys(selectedTickets);

        // check if place in inventory not busy by other tickets
        const availableTicketsBySchedule = selectedTicketIds.every(
            (ticketId) => !!currentVal.tickets_avail_by_duration[ticketId]
        );

        return availableTicketsBySchedule ? acc + Number(currentVal.max_places) : acc;
    }, 0);

    const ticketsSum = Object.values(selectedTickets).reduce((sum, count) => sum + count, 0);
    const ticketsAvail = Math.min(
        ...[schedule.tickets_avail, maxInventoryPlaces].filter((i) => Number(i) > 0)
    );

    const selectedTicketIds = Object.entries(selectedTickets)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_, value]) => !!value)
        .map(([key]) => key);

    // filter tickets which have min places more over all available places
    tickets = tickets
        .filter(
            ({ min, id }) =>
                ticketsAvail - ticketsSum - Number(min) >= 0 ||
                selectedTicketIds.includes(id.toString())
        )
        .filter(
            ({ id, duration }) =>
                !inventories.length ||
                inventories.some(
                    (inventory) =>
                        inventory.tickets_avail_by_duration[id] &&
                        (!inventory.duration || !duration || inventory.duration === duration)
                )
        );

    const selectedTicketsData = tickets.filter(({ id }) =>
        selectedTicketIds.includes(id.toString())
    );

    const selectedDuration = selectedTicketsData.reduce(
        (res, item) =>
            item.duration && !res.includes(item.duration) ? [...res, item.duration] : res,
        [] as string[]
    );

    const maxTicketsSelected = !!(ticketsAvail && ticketsAvail <= ticketsSum);

    let ticketsResult = maxTicketsSelected ? selectedTicketsData : tickets;

    // Check if tickets list have different duration
    if (selectedDuration.length && selectedDuration.length === inventories.length) {
        ticketsResult = ticketsResult.filter(
            ({ duration }) => duration === null || selectedDuration.includes(duration)
        );
    }

    return {
        tickets: ticketsResult,
        maxTicketsSelected,
    };
};
